import React from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  return (
    
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Fashion Loop. All rights reserved.</p>
      </div>
    
  );
}

export default Footer;